import _every from 'lodash/every'

export const FeatureFlags = {
  DOWNTIME: 'downtime',
  // Enable address validation for all addresses
  NEW_ADDRESS_VALIDATION: 'new_address_validation',
  // Enable breakup bundles
  BREAKUP_BUNDLES: 'breakup_bundles',
  // Enable simple store
  SIMPLE_STORE: 'simple_store',
  // Enable timezone-aware operating hours validation
  OPERATING_HOURS_VALIDATION: 'operating_hours_validation',
  // Enable displaying conflicting orders and downtimes in shortage errors
  AVAILABILITY_CONFLICTS: 'availability_conflicts'
}

/**
 * Checks if feature is enabled.
 */
export const featureEnabled = (...features) => {
  const state = (window.store || window.booqableGetStore?.())?.getState()
  const featuresArray = state.session?.enabledFeatures || state.client?.enabledFeatures

  return _every(features, (feature) => {
    return (featuresArray || []).includes(feature)
  })
}

/**
 * Checks if feature is disabled.
 */
export const featureDisabled = (...features) => !featureEnabled(...features)

/**
 * Back office only
 * Checks if feature is part of subscription.
 */
export const featureAllowed = (...features) => {
  const state = window.store?.getState()

  return _every(features, (feature) => {
    return (state.session.features || []).includes(feature)
  })
}
